import React from 'react';

const AccountDeletionPage = () => {
  return (
    <div className="deletion-container">
      <div className="deletion-content">
        <h1>계정 삭제 요청</h1>
        <p className="subtitle">WowOrder 계정 및 관련 데이터 삭제 안내</p>

        <section>
          <h2>계정 삭제 요청 방법</h2>
          <p>아래 이메일로 계정 삭제를 요청해 주세요. 요청 접수 후 영업일 기준 7일 이내에 처리됩니다.</p>
          <div className="info-box">
            <p><strong>삭제 요청 이메일</strong></p>
            <p className="email">official@woworder.kr</p>
            <p className="note">메일 제목에 "계정 삭제 요청"을 포함하고, 가입 시 사용한 사업자 번호 및 전화번호를 기재해 주세요.</p>
          </div>
        </section>

        <section>
          <h2>삭제되는 데이터</h2>
          <p>계정 삭제 시 다음 데이터가 영구적으로 삭제됩니다.</p>
          <ul>
            <li>계정 정보 (이름, 이메일, 비밀번호)</li>
            <li>매장 정보 (매장명, 주소, 전화번호)</li>
            <li>메뉴 데이터 (카테고리, 메뉴 항목, 옵션)</li>
            <li>테이블 및 QR 코드 연결 정보</li>
            <li>배너 이미지 및 공지사항</li>
          </ul>
        </section>

        <section>
          <h2>보관되는 데이터</h2>
          <p>관계 법령에 따라 일부 데이터는 일정 기간 보관 후 파기됩니다.</p>
          <ul>
            <li>주문 처리 기록 - 5년 (전자상거래법)</li>
            <li>접속 로그 - 3개월 (통신비밀보호법)</li>
          </ul>
          <p>보관 기간이 만료되면 해당 데이터도 영구 삭제됩니다.</p>
        </section>

        <section>
          <h2>유의사항</h2>
          <ul>
            <li>계정 삭제 후에는 동일한 계정으로 재가입이 불가합니다.</li>
            <li>삭제된 데이터는 복구할 수 없습니다.</li>
            <li>삭제 처리 완료 시 이메일로 안내드립니다.</li>
          </ul>
        </section>
      </div>

      <style jsx>{`
        .deletion-container {
          min-height: 100vh;
          background-color: #fff;
          padding: 20px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
        .deletion-content {
          max-width: 800px;
          margin: 0 auto;
          padding: 40px 0;
        }
        h1 {
          font-size: 28px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 8px 0;
          text-align: center;
        }
        .subtitle {
          text-align: center;
          color: #888;
          font-size: 14px;
          margin-bottom: 40px;
        }
        section {
          margin-bottom: 32px;
        }
        h2 {
          font-size: 18px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 12px 0;
          padding-bottom: 8px;
          border-bottom: 1px solid #eee;
        }
        p {
          font-size: 14px;
          line-height: 1.7;
          color: #444;
          margin: 0 0 8px 0;
        }
        ul {
          margin: 8px 0;
          padding-left: 20px;
        }
        li {
          font-size: 14px;
          line-height: 1.7;
          color: #444;
          margin-bottom: 4px;
        }
        .info-box {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 20px;
          margin-top: 12px;
        }
        .info-box p {
          margin: 4px 0;
        }
        .email {
          font-size: 18px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 8px 0;
        }
        .note {
          font-size: 13px;
          color: #888;
        }
        @media (max-width: 600px) {
          .deletion-container {
            padding: 12px;
          }
          .deletion-content {
            padding: 24px 0;
          }
          h1 {
            font-size: 22px;
          }
          h2 {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default AccountDeletionPage;
